export default function Credit() {
  return (
    <div className="center_container">
      <ul>
        <li><span>Reporter</span> | Xia Nianzi, Zhang Taige, Mengyu, mulan, Wuyan</li>
        <li><span>Contributing Opinion Writer</span> | Zhong Shan</li>
        <li><span>Editor</span> | Mimi Qin, Rosa Ng, John Tsang, Larry Fish</li>
        <li><span>Data Editor</span> | Paul Wang</li>
        <li><span>Video Producer</span> | X, Yusef Evans</li>
        <li><span>Video Editor</span> | Danni Gao, Yijo S.</li>
        <li><span>Executive Producer for Videos</span> | Vivian Lee</li>
        <li><span>Illustrator</span> | missquai</li>
        <li><span>Web Designer and Developer</span> | Vic Kim</li>
        <li><span>Article Page Producer</span> | Regina Li</li>
        <li><span>Art Director</span> | Chris Wong</li>
        <li><span>Executive Producer</span> | Mimi Qin</li>
        <li><span>Translator</span> | Luisetta Mudie, Timothy Ditter</li>
        <li><span>Editor-in-Chief</span> | Alex Zhang</li>
        <li><span>Executive Editor</span> | Min Mitchell</li>
      </ul>
    </div>
  )
}
